// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"iH","cusMtdicon":"iH"};